import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '../i18n/i18n.module';

import { GalleryComponent } from '@shared/gallery/gallery.component';
import { SharedPipesModule } from './shared-pipes.module';
import {LazyLoadImageModule, scrollPreset} from 'ng-lazyload-image';
import {isBot} from './shared-2plus1.module';
import {GalleryFiltersComponent} from '@shared/gallery/gallery-filters/gallery-filters.component';


@NgModule({
  declarations: [
    GalleryComponent,
    GalleryFiltersComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    SharedPipesModule,
    LazyLoadImageModule.forRoot({
      preset: scrollPreset, // <-- tell LazyLoadImage that you want to use scrollPreset
      isBot
    })
  ],
  providers: [

  ],
  bootstrap: [],
  exports: [
    GalleryComponent,
    GalleryFiltersComponent
  ]
})
export class SharedGalleryModule { }
